<!-- 订单管理-充电订单 -->

<template>
	<div class="charging-order main-cnt">
		<div class="content">
			<common-table ref="roleTable" tableHeight="calc(100vh - 325px)" :ischeck="false" :ispaging="true"
				:extraParame="{req_type:'6'}" 
				:apiName="Order.getParkingOrderLists" :filters="filters" :columns="tableColumns"
				@onDetailBtn="onDetailBtn"  >
			
			</common-table>
		</div>
		<!-- 订单详情 -->
		<parkingOrderDetail ref="detailsDialog" :orderDetails="orderDetails" @onClickUser="onClickUser"></parkingOrderDetail>

		
	</div>
</template>

<script setup>
	import {
		ref,
		onMounted,
		computed,
		watch,
	} from "vue";
	import {
		Order,
	} from "@/plugins/api.js";
	import {
		ElMessage
	} from "element-plus";
	import {
		useStore
	} from "vuex";
	import dayjs from "dayjs";
	import parkingOrderDetail from "../components/parkingOrderDetail.vue";
	import getBaseUrl from "@/plugins/baseUrl.js";
	const baseUrl = getBaseUrl() ? getBaseUrl() : "";
	const store = useStore();
	const menuTokens = computed(() => store.state.menuToken.menuTokens);
	const authData = ref([]);

	// 监听权限
	watch(() => menuTokens.value, (data) => {
		if (data.length) {
			authData.value = data;
		}
	}, {
		deep: true,
		immediate: true,
	})

	/** 表格对象 */
	const roleTable = ref(null);

	const detailsDialog = ref(null); // 详情对象
	const orderDetails = ref({}); // 订单详情数据
	/** 筛选条件列表 */
	const filters = ref([{
			name: "keywords",
			filterType: "search",
			value: "",
			placeholder: "请输入订单编号、支付单号或手机号查询",
		},{
			filterType: "date",
			name: "start_time",
			name2: "end_time",
			value: [dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD")],
			// value: [],
			placeholder: "请选择日期范围",
			type: "daterange",
		}

	]);

	/** 表格配置数据 */
	const tableColumns = ref([{
			prop: "ot_no",
			label: "账单编号",
			color: "--text-color",
			showTooltip: true,
			minWidth: 150
		},
		{
			prop: "orp_no",
			label: "支付单号",
			color: "--text-color",
			showTooltip: true,
			minWidth: 150
		},
		{
			prop: "ot_total_money",
			label: "账单金额",
			color: "--text-color",
			showTooltip: true,
		},
		{
			prop: "m_mobile",
			label: "绑定用户",
			color: "--text-color",
			showTooltip: true,
		},
		{
			prop: "ot_plate",
			label: "车牌号码",
			color: "--text-color",
			showTooltip: true,
		},
		{
			prop: "ot_discount_money",
			label: "优惠金额",
			color: "--text-color",
			showTooltip: true,
		},
		{
			prop: "ot_integral_money",
			label: "积分抵扣金额",
			color: "--text-color",
			showTooltip: true,
		},
		{
			prop: "or_status_title",
			label: "订单状态",
			type: "option",
			metaData: ["待交", "已支付", "订单取消", "已退款", "欠款待交"],
			colorData: ["var(--text-blue-color)", "var(--theme-color)", "var(--error-color)", ],
			showTooltip: true,
		},
		
		{
			prop: "s_name",
			label: "充电站",
			color: "--text-color",
			showTooltip: true,
		},
		{
			prop: "ot_pay_money",
			label: "支付金额",
			color: "--warning-color",
			showTooltip: true,
		},
		{
			prop: "ot_send_coupon_endtime",
			label: "支付时间",
			color: "--text-color",
			showTooltip: true,
		},
		{
			type: "operation",
			prop: "",
			label: "操作",
			minWidth: 100,
			bottons: [{
				name: "详情",
				action: "onDetailBtn",
				token: "n_bGljDyH6WfXoQSwy8288jefbfd",
			}, ],
		},
	]);
	

	
	/**
	 * 
	 * 查看详情按钮
	 * 
	 * */
	const onDetailBtn = (row) => {
		Order.getParkingOrderInfo({
			ot_id: row.ot_id
		}).then((res) => {
			if (res.Code === 200) {
				
				detailsDialog.value.openDialog();
				orderDetails.value = res.Data.data;
				console.log(orderDetails.value );
			} else {
				ElMessage.error(res.Message);
			}
		});
	}
	const refCommonChargingOrder = ref(null);
	/**
	 * 
	 * 订单详情-点击用户名称
	 * 
	 * */
	const onClickUser = (data) => {
	
		refCommonChargingOrder.value.show(data.m_id);
	}


	onMounted(() => {
		roleTable.value.tableLoad();
	});
</script>

<style lang="scss">
	.charging-order {
		font-family: "Source Han Sans CN";

		.el-row {
			border: none;
		}

		.search-input {
			width: 300px !important;
		}

		.content {
			padding: 20px;
		}

		.add-dialog {
			.el-dialog__body {
				padding: 20px 20px 30px 30px;
			}
		}

		.bg-color {
			background-color: #F4FDFA;
		}
	}

	.amount {
		margin-top: 10px;
		justify-content: space-between;
	}

	.amount-title {
		font-size: 18px;
	}

	.order-total {
		margin-left: 270px;
		color: #1AC994;
	}

	.total-paid {
		margin-right: 190px;
		color: #1AC994;
	}

	.order-left {
		margin-bottom: 20px;
		padding: 20px;
	}

	.charging-state {
		margin-bottom: 20px;
	}

	.charged {
		padding: 20px 30px;
	}

	.time-on {
		padding: 22px 20px;
	}

	.order-right {
		padding: 20px 15px !important;
	}

	.charging-img {
		width: 50px;
		height: 50px;
	}
</style>